import React from "react";
import { Divider } from "@mui/material";
import profile from "../../service/Mainservice";
import { useEffect } from "react";
import { useState } from "react";
import "./Profile.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import profileimg from "../../assets/agent (2).png";

const Profile = () => {
  const [profiledata, setprofiledata] = useState({});
  const { fullName, email, image } = profiledata;

  const navigate = useNavigate();
  useEffect(() => {
    getprofile();
  }, []);

  const getprofile = async () => {
    try {
      const data = await profile();
      setprofiledata(data.data.data[0]);
    } catch (error) {
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  return (
    <>
      <div className="profileoptions">
        <li className="active_profile">
          <Link to="/Profile">Profile Info</Link>
        </li>
        <li>
          <Link to="/EditProfile">Update Profile</Link>
        </li>
        <li>
          <Link to="/ChangePassword">Change Password</Link>
        </li>
      </div>

      <div className="profiledata">
        <div className="profiledata_up" />
        <img
          className="profileimg"
          alt="profile"
          src={image}
          // src={profileimg}
        />
        <div>
          <p className="profiledetails">
            UserName :<span>{fullName}</span>
          </p>
          <p className="profiledetails">
            Email :<span>{email}</span>
          </p>
          {/* <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
            <ColorButton variant="contained">Change Password</ColorButton>
            <ColorButton variant="contained">Edit Profile</ColorButton>
          </Box> */}
        </div>
        <Divider variant="middle" sx={{ bgcolor: "divider", marginTop: 42 }} />
      </div>
    </>
  );
};

export default Profile;
